import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JobType } from '../models/job-type.models';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';

@Injectable({
  providedIn: 'root'
})
export class JobTypeService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readJobTypes(): Observable<JobType[]> {
    return this.#http.getData(`${this.baseUrl}/JobType`, { showLoader: true, showMessage: false });
  }

  createJobType(jobType: JobType): Observable<JobType> {
    return this.#http.postData(`${this.baseUrl}/JobType`, { showLoader: true, showMessage: true }, jobType);
  }

  updateJobType(jobType: JobType, id: string): Observable<JobType> {
    return this.#http.putData(`${this.baseUrl}/JobType/${id}`, jobType, { showLoader: true, showMessage: true });
  }

  deleteJobType(id: string): Observable<JobType[]> {
    return this.#http.deleteData(`${this.baseUrl}/JobType/${id}`, { showLoader: true, showMessage: true });
  }

  getJobTypeById(id: string): Observable<JobType> {
    return this.#http.getData(`${this.baseUrl}/JobType/${id}`, { showLoader: true, showMessage: false });
  }
}
